export default "__VITE_ASSET__CRsvmjqG__"